import { render, staticRenderFns } from "./OrganizationViewSubscriptions.vue?vue&type=template&id=b0066fca"
import script from "./OrganizationViewSubscriptions.vue?vue&type=script&lang=js"
export * from "./OrganizationViewSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports